import { createSlice } from '@reduxjs/toolkit';

import { JSON_QUERY_DEFAULT } from '../../constants/jsonQueryDefault';

/* istanbul ignore next */
const jsonQuerySlice = createSlice({
  initialState: JSON_QUERY_DEFAULT,
  name: 'jsonQuery',
  reducers: {},
});

export const { reducer: jsonQueryReducer } = jsonQuerySlice;
